export const dataDateRanges = {
  Today: 'Today',
  Yesterday: 'Yesterday',
  ThisWeekFromSun: 'ThisWeekFromSun',
  ThisWeekFromMon: 'ThisWeekFromMon',
  Last7Days: 'LastSevenDays',
  LastWeekStartingSun: 'LastWeekStartingSun',
  LastWeekStartingMon: 'LastWeekStartingMon',
  LastBusinessWeek: 'LastBusinessWeek',
  Last14Days: 'LastFourteenDays',
  ThisMonth: 'ThisMonth',
  Last30Days: 'LastThirtyDays',
  LastMonth: 'LastMonth',
  Last3Month: 'LastThreeMonths',
  Last6Month: 'LastSixMonths',
  ThisYear: 'ThisYear',
  LastYear: 'LastYear',
  AllTime: 'AllTime',
};

export const frequencyGrains = {
  Hourly: 4,
  Daily: 0,
  Weekly: 1,
  Monthly: 2,
  Once: 3,
};

export const weeklyOptions = {
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
  Sunday: 0,
};
